var _circle, _circle2, _ellipse, _ellipse2, _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearnerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 195,
    viewBox: "0 0 185 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    fill: "#8FACCF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    fill: "url(#paint0_linear_11_1155)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_1155",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 48,
    width: 103,
    height: 147
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.5001,
    cy: 74.5663,
    rx: 27.5893,
    ry: 26.5663,
    fill: "#333333"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.5,
    cy: 150.723,
    rx: 51.5,
    ry: 44.2771,
    fill: "#333333"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_1155)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.0402,
    cy: 81.2078,
    rx: 85.067,
    ry: 81.9127,
    fill: "#E9E4D4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 112.375C126.42 110.521 106.9 115.586 91 126.579V185C106.9 173.884 126.42 168.819 144 170.796V112.375Z",
    fill: "#D1D4D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112.375C56.2485 110.521 75.4002 115.586 91 126.579V185C75.4002 173.884 56.2485 168.819 39 170.796V112.375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150 141.75C150 140.5 149.297 139.5 148.311 139.5C149.155 139.5 150 138.5 150 137.251C150 136.001 149.297 135 148.311 135H141.691C140.845 135 140 136.001 140 137.251C140 138.5 140.705 139.5 141.691 139.5C140.845 139.5 140 140.5 140 141.75C140 143 140.705 144.001 141.691 144.001C140.845 144.001 140 145 140 146.25C140 147.5 140.705 148.5 141.691 148.5C140.845 148.5 140 149.5 140 150.749C140 151.999 140.705 153 141.691 153H148.311C149.155 153 150 151.999 150 150.749C150 149.5 149.297 148.5 148.311 148.5C149.155 148.5 150 147.5 150 146.25C150 145 149.297 144.001 148.311 144.001C149.155 144.001 150 143 150 141.75Z",
    fill: "#E9E4D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 141.75C43 140.5 42.3653 139.5 41.4783 139.5C42.2392 139.5 43 138.5 43 137.251C43 136.001 42.3653 135 41.4783 135H35.5197C34.7589 135 34 136.001 34 137.251C34 138.5 34.6327 139.5 35.5197 139.5C34.7589 139.5 34 140.5 34 141.75C34 143 34.6327 144.001 35.5197 144.001C34.7589 144.001 34 145 34 146.25C34 147.5 34.6327 148.5 35.5197 148.5C34.7589 148.5 34 149.5 34 150.749C34 151.999 34.6327 153 35.5197 153H41.4783C42.2392 153 43 151.999 43 150.749C43 149.5 42.3653 148.5 41.4783 148.5C42.2392 148.5 43 147.5 43 146.25C43 145 42.3653 144.001 41.4783 144.001C42.3653 144.001 43 143 43 141.75Z",
    fill: "#E9E4D4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_1155",
    x1: 93,
    y1: -40,
    x2: 92.5,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0426985,
    stopColor: "#25374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768372,
    stopColor: "#547BAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnerIcon);
export default __webpack_public_path__ + "static/media/Learner Icon.ffa44009535e9a648bffcf9e3dff7412.svg";
export { ForwardRef as ReactComponent };